import gsap from "gsap";

export default function Stats() {
  Alpine.data("stats", () => ({
    resizeObserver: null,
    resizeTimeout: null,
    open: false,

    init() {
      // Optimize resize handling
      this.adjustNumberSizes = this.adjustNumberSizes.bind(this);
      this.debouncedResize = this.debouncedResize.bind(this);

      window.addEventListener("resize", this.debouncedResize);
      setTimeout(() => {
        this.adjustNumberSizes();
      }, 100);

      // Initialize counters only once
      setTimeout(() => {
        this.initCounters();
      }, 500);
    },

    debouncedResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.adjustNumberSizes, 200);
    },

    async initCounters() {
      // const { CountUp } = await import("countup.js");
      // this.$el.querySelectorAll("[data-number]").forEach((el) => {
      //   const counter = new CountUp(el, el.innerHTML, {
      //     useGrouping: false,
      //     // separator: ".",
      //     decimal: ",",
      //     startVal: 0,
      //     duration: 1,
      //     scrollSpyOnce: true,
      //     scrollSpyDelay: 0.35,
      //     enableScrollSpy: true,
      //     useIndianSeparators: false,
      //     decimalPlaces: 1,
      //     onCompleteCallback: () => {
      //       if (el.parentElement && el.parentElement.children) {
      //         el.parentElement.children[0].classList.remove("opacity-0");
      //       }
      //       el.remove();
      //     },
      //   });
      //   counter.start();
      // });
    },

    adjustNumberSizes() {
      const containers = this.$el.querySelectorAll("[data-numberwrapper]");
      const fontSizes = [];

      requestAnimationFrame(() => {
        containers.forEach((el) => {
          const parent = el.parentElement;
          el.style.whiteSpace = "nowrap";
          el.style.display = "inline-flex";

          let lo = 1,
            hi = 1000;
          while (lo < hi) {
            const mid = Math.ceil((lo + hi) / 2);
            el.style.fontSize = mid + "px";
            if (
              el.scrollWidth > parent.clientWidth ||
              el.scrollHeight > parent.clientHeight
            ) {
              hi = mid - 1;
            } else {
              lo = mid;
            }
          }

          fontSizes.push(lo);
        });

        const minFontSize = Math.min(...fontSizes);
        const maxFontSize = Math.min(minFontSize, 90);

        containers.forEach((el) => {
          el.style.fontSize = maxFontSize + "px";
        });
      });
    },
  }));
}
